import { takeLatest, put, all, throttle, select } from 'redux-saga/effects';
import {
  LOAD_COMMISSION_SHOW,
  setCommissionShow,
  CHANGE_PAGE,
  setCommissionDirectMerchants,
  setCommissionPartners,
  UPDATE_LOAD_COMMISSION_SHOW,
  commissionShowFailed,
  commissionUpdateShowFailed,
  DOWNLOAD_CSV,
  SET_PER_PAGE_FILTER,
  ORDER_BY_DIRECT_MERCHANTS_PROCESSING_VOLUME,
  ORDER_BY_DIRECT_MERCHANTS_TRANSACTION_FEE,
  ORDER_BY_DIRECT_MERCHANTS_COMMISSION,
  ORDER_BY_PARTNERS_NUM_MERCHANTS,
  ORDER_BY_PARTNERS_PROCESSING_VOLUME,
  ORDER_BY_PARTNERS_TRANSACTION_FEE,
  ORDER_BY_PARTNERS_COMMISSION,
  ORDER_BY_DIRECT_MERCHANTS_CREATED_AT,
  ORDER_BY_DIRECT_MERCHANTS_MERCHANT_NAME,
  ORDER_BY_PARTNERS_COMPANY_NAME
} from './reducer';
import { calculatePagination } from '../../../utilities/misc';
import { handleLoadReferralCryptoWallets } from '../../Account/CryptoWallets/sagas';
import { setPaginatorTotal } from './reducer';
import {
  loadCommissionSummary,
  loadDirectMerchantCommission,
  loadPartnerCommission,
  handleLoadUpdateCommission
} from '../../../utilities/commissionPayouts/sagas/show';
import { handleLoadReferralBankDetails } from '../../Account/BankAccount/sagas';

function handleLoadSummary(action) {
  const path = 'commission_payouts';
  return loadCommissionSummary(action, path);
}

function handleLoadDirectMerchantCommission(action) {
  const url = `/commission_payouts/${action.params.id}/commissions`;
  return loadDirectMerchantCommission(action, url);
}

function handleLoadPartnerCommission(action) {
  const url = `/commission_payouts/${action.params.id}/referral_details`;
  return loadPartnerCommission(action, url);
}

function* handleLoadCommissionPaidShow(action) {
  try {
    const [summaryResponse, directMerchantsResponse] = yield all([
      handleLoadSummary(action),
      handleLoadDirectMerchantCommission(action),
      handleLoadReferralCryptoWallets(),
      handleLoadReferralBankDetails()
    ]);

    yield put(
      setCommissionShow(
        summaryResponse.data,
        directMerchantsResponse.data,
        summaryResponse.data.currency
      )
    );
  } catch (error) {
    yield put(commissionShowFailed());
  }
}

function* handleCommissionPaidUpdateShow(action) {
  try {
    const id = yield select(
      state => state.commissionPayouts.commissionPaid.show.summary.id
    );
    const options = {
      slice: {
        commissionType: 'commissionPaid',
        id
      },
      method: {
        calculatePagination,
        setPaginatorTotal,
        setCommissionDirectMerchants,
        setCommissionPartners,
        handleLoadDirectMerchantCommission,
        handleLoadPartnerCommission
      }
    };
    yield handleLoadUpdateCommission(action, options);
  } catch (error) {
    yield put(commissionUpdateShowFailed());
  }
}

export function* commissionPaidShowSaga() {
  yield takeLatest([LOAD_COMMISSION_SHOW], handleLoadCommissionPaidShow);
}

export function* commissionPaidUpdateShowSaga() {
  yield takeLatest(
    [
      UPDATE_LOAD_COMMISSION_SHOW,
      CHANGE_PAGE,
      SET_PER_PAGE_FILTER,
      ORDER_BY_DIRECT_MERCHANTS_CREATED_AT,
      ORDER_BY_DIRECT_MERCHANTS_MERCHANT_NAME,
      ORDER_BY_DIRECT_MERCHANTS_PROCESSING_VOLUME,
      ORDER_BY_DIRECT_MERCHANTS_TRANSACTION_FEE,
      ORDER_BY_DIRECT_MERCHANTS_COMMISSION,
      ORDER_BY_PARTNERS_COMPANY_NAME,
      ORDER_BY_PARTNERS_NUM_MERCHANTS,
      ORDER_BY_PARTNERS_PROCESSING_VOLUME,
      ORDER_BY_PARTNERS_TRANSACTION_FEE,
      ORDER_BY_PARTNERS_COMMISSION
    ],
    handleCommissionPaidUpdateShow
  );
}

export function* downloadCommissionPaidShowCsvSaga() {
  yield throttle(5000, DOWNLOAD_CSV, handleCommissionPaidUpdateShow);
}
